/**
 * Calculate gross profit percentage (capped at 99.99%)
 */
export const calculateGrossProfitPercentage = (
  cost: number,
  sell: number
): number => {
  if (sell === 0) return 0;
  return Math.min(((sell - cost) / sell) * 100, 99.99);
};

/**
 * Format currency for display
 */
export const formatCurrency = (value: number): string =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
